module.exports = __webpack_public_path__ + "img/jiaoyu_image.94cd1d7f.png";